import { createSelector } from 'reselect'

const getData = (state, id, transform, filter) => {
  // if (id === 'WellsiteRankPoint') {
  //   console.log(id)
  //   console.log(state.data)
  // }
  // if(id === 'InfrastructurePipelineFeatures') {
  //   console.log(state.data)
  // }
  return state.data[id]
}

const getId = (state, id, transform, filter) => {
  return id
}

const getTransform = (state, id, transform, filter) => {
  const defaultTransform = data => data
  return transform || defaultTransform
}

const getFilter = (state, id, transform, filter) => {
  return filter
}

export const makeGetData = () => {
  return createSelector(
    [getData, getId, getTransform, getFilter],
    (data, id, transform, filter) => {
      if (data) {
        const transformedData = transform(data, filter)
        return transformedData.asMutable ? transformedData.asMutable() : transformedData
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/dataSelector.js